/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


window.Vue = require('vue').default;
window.Vue.config.productionTip = false;
const $ = window.$;
const Vue = window.Vue;
const moment = require('moment');

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

/**
 * vue-waypoint
 * - https://github.com/scaccogatto/vue-waypoint
 */
import VueWaypoint from 'vue-waypoint'
Vue.use(VueWaypoint)


import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  // set observer to true
  observer: true,

  // optional
  observerOptions: {
    rootMargin: '500%',
    threshold: 0
  }
});

import VCalendar from 'v-calendar';
Vue.use(VCalendar, {})

if(process.env.APP_ENV !== 'production') {
  Vue.config.devtools = true;
}

/**
 * IE 11 Detection
 */
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
if(isIE11) {
  $('#outdated-browser-modal').modal('show');
}
/**
 * Vue filter to format date using moment
 *
 * @param {String} value The value string.
 */
 Vue.filter('formatDate', function (date, format) {
  return moment.utc(date).format(format);
});

Vue.filter('numberWithCommas', function(value) {
  if (value == null) {
      return 0;
  }
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

/**
 * Vue filter to convert the given value to whole dollars, no change.
 * http://jsfiddle.net/bryan_k/2t6bqqfc/
 *
 * @param {String} value The value string.
 */
 Vue.filter('noChange', function(value, symbol, round = false) {
  if(!value) { value = 0; }
  if(!symbol) { symbol = '$'; }
  if(round){ value = Math.round(value); }
  value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',').split('.')[0];
  return symbol + '' + value;
});

/**
 * Vue filter to convert the first character of a string to uppercase
 * https://vuejs.org/v2/guide/filters.html
 *
 * @param {String} value The string to capitalize.
 */
 Vue.filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

/**
 * Vue filter to return a human-readable date\time difference from current date\time
 *
 * @param {String} value The value string.
 */
 Vue.filter('timeAgo', function (date) {
  let dateUTC = moment.utc(date);
  return dateUTC.fromNow();
});

/**
  * Vue filter to convert the given value to a percentage, with a given number of decimals.
  * http://jsfiddle.net/bryan_k/2t6bqqfc/
  *
  * @param {String} value The value string.
  * @param {Number} decimals The number of decimal places to round to.
  */
 Vue.filter('percentage', function(value, decimals) {
  if(!value) {
    value = 0;
  }

  if(!decimals) {
    decimals = 0;
  }

  value = value * 100;
  value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  value = value + ' ' + '%';
  return value;
});


// Filters -- Used across all vue integration
// Vue.filter('reduceByPercentage', require('@vue/filters/reduce-by-percentage.js'));
// Vue.filter('increaseByPercentage', require('@vue/filters/increase-by-percentage.js'));
// Vue.filter('noChangeRound', require('@vue/filters/no-change-round.js'));